module.exports = __webpack_public_path__ + "static/monster-70e8b65f90f259755024683deac5c1b8.gif";